import { TopPercentileBands } from '../index'

export default function checkTopPercentile (score: number, min: number, max: number): TopPercentileBands | undefined {
  const rangeLength: number = max - min

  const top10PercentCutoff: number = max - 0.1 * rangeLength
  const top5PercentCutoff: number = max - 0.05 * rangeLength
  const top1PercentCutoff: number = max - 0.01 * rangeLength

  if (score >= top1PercentCutoff) {
    return TopPercentileBands.Top1
  }
  if (score >= top5PercentCutoff) {
    return TopPercentileBands.Top5
  }
  if (score >= top10PercentCutoff) {
    return TopPercentileBands.Top10
  }

  return undefined
}
